import React from "react";
import { Link } from "react-router-dom";
import "materialize-css";

const links = [
  ["/team", "Team"],
  ["/acquisition-criteria", "Acquisition Criteria"],
  ["/property-portfolio", "Property Portfolio"],
  ["/contact", "Contact"],
];

class Navbar extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    M.AutoInit();
  }

  render() {
    return (
      <div className="navbar-fixed">
        <nav style={{ opacity: ".9"}}>
          <div
            id="nav-wrapper"
            className="nav-wrapper light-blue darken-4"
            // style={{ height: "100px" }}
          >
            <Link to="/" className="brand-logo" id="nav-logo">
              <img id="navbar-logo" src="/images/logos/GPGlogo.png" />
            </Link>
            <a href="#" data-target="mobile-demo" className="sidenav-trigger">
              <i className="material-icons">menu</i>
            </a>
            <ul className="right hide-on-med-and-down">
              {links.map((link, idx) => {
                return (
                  <li key={idx}>
                    <Link to={link[0]} className="navbar-page">
                      {link[1]}
                    </Link>
                  </li>
                );
              })}
              <li>
                <Link
                  to="/investor-login"
                  className="navbar-page"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Investor Login
                </Link>
              </li>
            </ul>
          </div>
        </nav>

        <ul className="sidenav" id="mobile-demo">
          {links.map((link, idx) => {
            return (
              <li key={idx} className="sidenav-close">
                <Link to={link[0]}>{link[1]}</Link>
              </li>
            );
          })}
          <li>
            <Link
              to="/investor-login"
              className="navbar-page"
              target="_blank"
              rel="noopener noreferrer"
            >
              Investor Login
            </Link>
          </li>
        </ul>
      </div>
    );
  }
}

export default Navbar;
